import { motion } from 'framer-motion';
import { Users, Award, Briefcase, ClipboardList, DollarSign, UserCheck, Hotel, Monitor, Globe, Handshake } from 'lucide-react';
import chiefPatronImg from '../assets/1 (1).png'
import president from '../assets/1 (2).png'
import propresident from '../assets/1 (3).png'
import registrar from '../assets/1 (4).png'
import provost from '../assets/1 (5).png'
import FoSTA from '../assets/1 (6).png'
import assdean from '../assets/rk-gupta.jpg'
import hodmech from '../assets/Prabhat-Ranjan.jpg'
import assprof from '../assets/333.jpg'
import assprofmech from '../assets/Krishna.jpg'
import pradeepimg from '../assets/Pradeep-Kundu.jpg'

const Committee = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.5 },
  };

  const leadership = [
    {
      title: 'Chief Patron',
      members: [{ name: 'S. Vaitheeswaran', designation: 'Chairperson, MUJ', photo: chiefPatronImg }],
    },
    {
      title: 'Patron',
      members: [{ name: 'Dr. Niti Nipun Sharma', designation: 'President, MUJ', photo: president }],
    },
    {
      title: 'Co-Patrons',
      members: [
        { name: 'Dr. Karunakar A. Kotegar', designation: 'Pro President', photo: propresident },
        { name: 'Dr. Amit Soni', designation: 'Registrar', photo: registrar },
        { name: 'Dr. Nitu Bhatnagar', designation: 'Provost', photo: provost},
      ],
    },
    {
      title: 'General Chairs',
      members: [
        { name: 'Dr. Kuldeep Sangwan', designation: 'Dean FoSTA', photo: FoSTA },
        { name: 'Dr. Ravi Kant Gupta', designation: 'Associate Dean, SoE', photo: assdean  },
      ],
    },
    {
      title: 'Program Chairs',
      members: [
        { name: 'Dr. Prabhat Ranjan', designation: 'HOD, Mechatronics', photo: hodmech },
        { name: 'Dr. Pradeep Kundu', designation: 'IIT, Indore ', photo: pradeepimg },
      ],
    },
    {
      title: 'Conference Conveners',
      members: [
        { name: 'Dr. Manish Rawat', designation: 'Associate Professor, Mechatronics', photo: assprof },
        { name: 'Dr. Krishna Kant Pandey', designation: 'Associate Professor, Mechatronics', photo: assprofmech },
      ],
    },
  ];

  const committees = [
    {
      title: 'Technical Program Committee (TPC)',
      responsibilities: [
        'Paper review and evaluation',
        'Maintaining publication quality',
        'Ensuring plagiarism compliance',
        'Recommending acceptance/rejection',
      ],
      members: [
        'Dr Mironmoy Mishra',
        'Dr Prabhat Ranjan',
        'Dr Shahbaz Ahmed Siddiqui',
        'Dr Pradeep Kundu',
        'Dr Satyabrata Roy',
        'Dr Manish Rawat',
        'Dr Krishnakant Pandey',
      ],
    },
    {
      title: 'Finance Committee',
      responsibilities: [
        'Budget planning',
        'Sponsorship handling',
        'Expense monitoring',
        'Audit documentation',
      ],
      members: [
        'Dr Ashok Kumar Kumawat (Lead)',
        'Dr Mohit Jain',
        'Dr Prabhat Ranjan',
        'Dr Manish Rawat',
        'Dr Krishnakant Pandey',
      ],
    },
    {
      title: 'Registration Committee',
      responsibilities: [
        'Author registration',
        'Payment verification',
        'Confirmation emails',
        'Conference Kit Preparation',
        'Certificates preparation',
      ],
      members: [
        'Dr Mohit Jain (Lead)',
        'Dr Ashok Kumar Kumawat',
        'Dr. Sankalp Paliwal',
        'Mr Rohit',
        'Mr Yogesh',
        
      ],
    },
    {
      title: 'Hospitality & Accommodation Committee',
      responsibilities: [
        'Guest Schedule preparation',
        'Guest Accommodation arrangements',
        'Transportation arrangement',
        'Food & High Tea management',
      ],
      members: [
        'Dr Varun Jurwall (Lead)',
        'Mr Balveer',
       
      ],
    },
    {
      title: 'Technical Session Management Committee',
      responsibilities: [
        'Session chair coordination',
        'AV support',
        'Time management',
        'Attendance recording',
        'Online Session arrangement',
        'Coordination with MUJ IT Infra',
      ],
      members: [
        'Dr Kumar Gaurav (Lead)',
        'Dr Nikhil Vivek Shrivas',
       
      ],
    },
    {
      title: 'Website & Publicity Committee',
      responsibilities: [
        'Website management',
        'Social media promotion',
        'Brochure/poster design',
        'Email communications',
      ],
      members: [
        'Dr Manish Rawat (Lead)',
        'Dr. Sankalp Paliwal',
        'Mr Rohit',
        'Dr. Mahesh Jangid',
      ],
    },
    {
      title: 'Sponsorship & Industry Collaboration Committee',
      responsibilities: [
        'Corporate tie-ups',
        'Exhibition stalls',
        'Industrial keynote coordination',
      ],
      members: [
        'Mr Hemant Kumar (Lead)',
        'Dr Nikhil Srivas',
        'Dr Kumar Gaurav',
      ],
    },
  ];

  const advisoryCommittee = [
    'Prof. Rajesh Kumar, IIT Delhi',
    'Prof. Sudipto Mukherjee, IIT Kharagpur',
    'Prof. Arun Kumar Singh, IIT Roorkee',
    'Prof. Vinay Sharma, IIT Bombay',
    'Prof. S. K. Saha, IIT Delhi',
    'Dr. John Anderson, MIT, USA',
    'Dr. Maria Garcia, Technical University of Munich, Germany',
    'Dr. Wei Zhang, Tsinghua University, China',
    'Dr. Yuki Tanaka, University of Tokyo, Japan',
    'Dr. Sarah Thompson, Oxford University, UK',
    'Dr. Ahmed Hassan, KAUST, Saudi Arabia',
    'Dr. Priya Sharma, NIT Trichy',
    'Dr. Anand Verma, NIT Warangal',
    'Dr. Kavita Reddy, BITS Pilani',
  ];

  return (
    <div data-testid="committee-page">
      {/* Hero Section */}
      <section className="py-12 md:py-12 mesh-gradient relative overflow-hidden" data-testid="committee-hero">
        <div className="absolute inset-0 bg-black/5 grid-pattern"></div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
          <motion.div {...fadeInUp} className="max-w-4xl">
            <div className="inline-flex items-center space-x-2 bg-[#B6671D]/10 text-[#B6671D]-dark rounded-full px-4 py-2 mb-6">
              <Users size={20} />
              <span className="font-inter text-sm font-medium">Meet the Team</span>
            </div>
            <h1 className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-950 mb-6 tracking-tight">
              Conference <span className="text-[#B6671D]">Committee</span>
            </h1>
            <p className="font-inter text-lg text-slate-600 leading-relaxed">
              IRASM-2027 is organized by a distinguished team of leaders from academia and industry.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Leadership Teams - Photo Left, Details Right */}
      <section className="py-20 bg-white" data-testid="leadership-teams">
       
       <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="space-y-16">
            {leadership.map((team, teamIndex) => (
              <motion.div
                key={teamIndex}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: teamIndex * 0.1 }}
                data-testid={`leadership-team-${teamIndex}`}
              >
                <div className="flex items-center space-x-3 mb-8">
                  <Award className="text-[#B6671D]" size={28} />
                  <h2 className="font-outfit text-3xl font-bold text-slate-950">{team.title}</h2>
                </div>

                <div className="space-y-6">
                  {team.members.map((member, memberIndex) => (
                    <div
                      key={memberIndex}
                      className="bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-lg hover:border-[#B6671D]/50 transition-all flex"
                      data-testid={`member-card-${teamIndex}-${memberIndex}`}
                    >
                      {/* Left - Photo Placeholder */}
                      <div className="w-40 h-40 bg-slate-100 flex-shrink-0 relative">
                        {member.photo ? (
                          <img src={member.photo} alt={member.name} className="w-full h-full object-cover" />
                        ) : (
                          <div className="absolute inset-0 flex items-center justify-center">
                            <Users className="text-slate-300" size={48} />
                          </div>
                        )}
                      </div>
                      
                      {/* Right - Details */}
                      <div className="p-6 flex-1 flex flex-col justify-center">
                        <h3 className="font-outfit text-xl font-bold text-slate-950 mb-1">{member.name}</h3>
                        {member.designation && (
                          <p className="font-inter text-[#B6671D] font-medium">{member.designation}</p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
      

      {/* Organizing Committees */}
      <section className="py-20 bg-slate-50" data-testid="organizing-committees">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div {...fadeInUp} className="mb-12">
            <div className="flex items-center space-x-3 mb-4">
              <ClipboardList className="text-[#B6671D]" size={28} />
              <h2 className="font-outfit text-3xl sm:text-4xl font-bold text-slate-950">Organizing Committees</h2>
            </div>
            <p className="font-inter text-slate-600">Meet the dedicated teams working behind the scenes to make IRASM-2027 a success.</p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {committees.map((committee, index) => {
              const icons = [ClipboardList, DollarSign, UserCheck, Hotel, Monitor, Globe, Handshake];
              const IconComponent = icons[index % icons.length];
              
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                  className="bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-lg hover:border-[#B6671D]/50 transition-all"
                  data-testid={`committee-card-${index}`}
                >
                  {/* Committee Header */}
                  <div className="bg-slate-950 p-5">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-[#B6671D] rounded-lg flex items-center justify-center flex-shrink-0">
                        <IconComponent className="text-white" size={20} />
                      </div>
                      <h3 className="font-outfit text-lg font-bold text-white">{committee.title}</h3>
                    </div>
                  </div>

                  {/* Committee Content */}
                  <div className="p-6">
                    {/* Responsibilities */}
                   {/* <div className="mb-5">
                      <h4 className="font-outfit text-sm font-semibold text-slate-500 uppercase tracking-wide mb-3">Responsibilities</h4>
                      <ul className="space-y-2">
                         {committee.responsibilities.map((resp, respIndex) => (
                          <li key={respIndex} className="flex items-start space-x-2">
                            <div className="w-1.5 h-1.5 bg-[#B6671D] rounded-full mt-2 flex-shrink-0"></div>
                            <span className="font-inter text-sm text-slate-600">{resp}</span>
                          </li>
                        ))} 
                      </ul>
                    </div>*/}

                    {/* Members */}
                    <div>
                      <h4 className="font-outfit text-sm font-semibold text-slate-500 uppercase tracking-wide mb-3">Committee Members</h4>
                      <div className="flex flex-wrap gap-2">
                        {committee.members.map((member, memberIndex) => (
                          <span
                            key={memberIndex}
                            className={`inline-block px-3 py-1.5 rounded-full text-sm font-inter ${
                              member.includes('(Lead)')
                                ? 'bg-[#B6671D]/10 text-[#B6671D]-dark font-medium'
                                : 'bg-slate-100 text-slate-700'
                            }`}
                          >
                            {member}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>


      {/* Advisory Committee */}
      <section className="py-20 bg-white" data-testid="advisory-committee">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div {...fadeInUp}>
            <div className="flex items-center space-x-3 mb-8">
              <Users className="text-[#B6671D]" size={28} />
              <h2 className="font-outfit text-3xl sm:text-4xl font-bold text-slate-950">Advisory Committee</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {advisoryCommittee.map((member, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.02 }}
                  className="bg-white border border-slate-200 rounded-lg p-4 hover:border-[#B6671D]/50 hover:shadow-md transition-all"
                  data-testid={`advisory-member-${index}`}
                >
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-[#B6671D] rounded-full mt-2 flex-shrink-0"></div>
                    <p className="font-inter text-slate-700">{member}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Committee;